import axios, { AxiosResponse} from "axios";
import {AjaxHelperResponse} from "./AjaxHelperResponse";

export class AjaxHelper {


    public static async get(url:string = "",data:object|null = {},headers:object|null = {}) : Promise<AjaxHelperResponse>{
        return await this.makeAjax("get",url,data,headers);
    }
    public static async post(url:string = "",data:object|null = {},headers:object|null = {}): Promise<AjaxHelperResponse>{
        return await this.makeAjax("post", url, data, headers);
    }

    public static async put(url:string = "",data:object|null = {},headers:object|null = {}): Promise<AjaxHelperResponse>{
        return await this.makeAjax("put", url, data, headers);
    }

    public static async delete(url:string = "",data:object|null = {},headers:object|null = {}): Promise<AjaxHelperResponse>{
        return await this.makeAjax("delete", url, data, headers);
    }

    protected static async makeAjax(method:string = "get" ,url:string = "",data:object|null = {},headers:object|null = {}) :  Promise<AjaxHelperResponse>{

        let prefix = ''

        if (url.startsWith('http://') || url.startsWith('https://')) {
            prefix = '';
        } else {
            prefix = '/ajax';
        }

        const response = await axios({
            method: method,
            url: prefix + url,
            data: data,
            headers: headers,
            validateStatus: function (status) {
                return status < 500 && status !== 404
            }
        });

        const ajaxResponse = new AjaxHelperResponse(response, response.headers.data_type);

        this.autoRedirect(ajaxResponse)


        return ajaxResponse;
    }

    protected static autoRedirect(ajaxResponse:AjaxHelperResponse){

        if(ajaxResponse.getDataType('redirect') && ajaxResponse.getData('redirect') !== null){
            window.location.href = <string>ajaxResponse.getData('redirect');
        }

    }

}
